import { PlusIcon } from '@radix-ui/react-icons'
import { Button } from './styles';

function ButtonCard() {
  return (
    <Button>
      <PlusIcon />
    </Button>
  );
}

export default ButtonCard;